import { useQuery } from '@tanstack/react-query';
import { auditApi } from '../lib/api';
import type { AuditLog, PaginatedResponse } from '../lib/types';

export function useAuditLogs(params?: {
  entityType?: 'PACK' | 'CELL' | 'CUSTOMER' | 'TEST';
  entityId?: string;
  action?: 'CREATE' | 'UPDATE' | 'DELETE' | 'SOFT_DELETE';
  limit?: number;
  lastKey?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page?: number;
}) {
  return useQuery<PaginatedResponse<AuditLog>>({
    queryKey: ['auditLogs', params],
    queryFn: async () => {
      return auditApi.list(params);
    },
  });
}
